export default function ({getters, state, commit, dispatch}, value) {
    commit('set', {
        old: JSON.stringify(getters.data),
        visible: false,
    });
    axios({
        method: 'post',
        url: '/tourclient/legend/updateLegend',
        data: 'request=' + JSON.stringify(getters.data),
    }).then(r => {
        window.app.$notify({
            title: 'Сохранение',
            message: 'Настройки успешно сохранены',
            type: 'success',
        });
    }).catch(e => {
        dispatch('error', e, {root: true});
    });
}